import React from "react";
import {AccordionItemProps} from "./AccordionItem/AccordionItem";
import styles from "./Accordion.module.scss";

type AccordionProps = {children: React.ReactElement<AccordionItemProps>[]};

const Accordion: React.FC<AccordionProps> = ({children}) => {
  return <div className={styles.wrapper}>{children}</div>;
};

export default Accordion;
